import React from 'react';
import { DisplayMode } from '../types';
import { Stack } from '../../stack';
import { Button } from '../../button';
import { useDatePickerAttributes } from '../hooks/useDatePickerAttributes';
import { useProviderConfig } from '../../provider';

export interface ConfirmSectionProps {
  displayMode: DisplayMode;
  onCancel?: () => void;
  onConfirm?: () => void;
  canConfirm?: boolean;
}

export const ConfirmSection: React.FC<ConfirmSectionProps> = ({
  displayMode,
  onCancel,
  onConfirm,
  canConfirm = true,
}) => {
  const { locale } = useProviderConfig();
  const { footer } = useDatePickerAttributes(displayMode);
  const {
    container: { style, ...footerProps },
  } = footer;
  return (
    <Stack gap={8} {...footerProps} css={style}>
      <Button {...footer.button} onClick={onCancel}>
        {locale?.DatePicker.footer.clear}
      </Button>
      <Button kind='primary' {...footer.button} disabled={!canConfirm} onClick={onConfirm}>
        {locale?.DatePicker.footer.ok}
      </Button>
    </Stack>
  );
};
